import { Link } from "react-router-dom";
import React, { useState, useEffect } from "react";

import CustomModal from "../Bar/CustomModal";
import CustomModalBlockUser from "../Bar/CustomModalBlockUser";
import Pagination from "../Bar/Pagination";
import API from "../../config/api";
import { exportToExcel } from "../Helper/exportToExcel";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import img1 from "./../../assets/assets_theme/img/avatar/1.jpg"
import img2 from "../../assets/assets_theme/img/avatar/2.jpg"

import * as XLSX from "xlsx";

import moment from 'moment';
import CustomModalApproveUser from "../Bar/CustomModalApproveUser";

const UserIndex = () => {
  const [page, setPage] = useState(1);
  const [data, setData] = useState(null);
  const [users, setUsers] = useState([]);
  const [total, setTotal] = useState(0);
  const [limit, setLimit] = useState(100);
  const [s, setS] = useState("");
  const [approve, setApprove] = useState(null); // null: All, 1: Approved, 0: Pending, -2: Block

  useEffect(() => {
    getAllUsers();
  }, []);

  const exportUsersToExcelClient = (data, filename) => {
    exportToExcel(data, filename);
  }

  const handleFileUpload = async (event) => {
    // event.preventDefault();
    let dataExcel = [];

    const file = event.target.files[0];
    if (!file)
      return;
    const reader = new FileReader();

    reader.onload = async (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array", cellText: false, cellDates: true });

      // Assuming the first sheet is the one you want
      const worksheet = workbook.Sheets[workbook.SheetNames[0]];
      const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

      //filterout 1 row
      const filteredData = jsonData.slice(1);

      let file_data = [];

      filteredData.forEach((row, index) => {
        // if (index != 0) ; // Original logic seemed to have a nop here or vestigial code.

        const date = new Date(row[3]);
        const formattedDate = moment(date).format("YYYY-MM-DD")

        if (row && row.length !== 0) {
          file_data.push({
            first_name: row[0],
            last_name: row[1],
            custom_id: row[2],
            dob: formattedDate,
          })
        }
      });

      try {
        let results = await API.postUser(file_data);
        if (results.result) {
          toast.success("Your action is successful", {
            data: {
              title: "Success toast",
              text: "This is a success message",
            },
          })
        }
        getAllUsers();

      } catch (error) {
        console.log(error)
      }
    };

    reader.readAsArrayBuffer(file);
  }

  const getAllUsers = async (extra_query = "") => {
    try {
      // Use current state for base params, allowing extra_query to override/append
      // Note: If calling from a place where state updates haven't propagated, pass explicit values.
      // Since this function relies on 'page', 's', 'limit' state, ensure they are up to date or passed.
      // But preserving original signature `getAllUsers(extra_query)`.

      let query = `${extra_query}&page=${page}&s=${s}&limit=${limit}`;

      let results = await API.getAllUsers(query);

      let resultData = results.data.result;

      setUsers(resultData.users);
      setTotal(resultData.total);
      setLimit(resultData.limit);

    } catch (error) {
      console.log(error)
    }
  }

  // Helper to fetch keys when state might be stale (e.g. search input change)
  const fetchUsers = async (queryS, queryPage, queryLimit, extraQuery = "") => {
    try {
      // If extraQuery is undefined/null, use valid string
      const extra = extraQuery || getCurrentApproveQuery();
      // Original code passed "approve=1" etc manually.

      let query = `${extra}&page=${queryPage}&s=${queryS}&limit=${queryLimit}`;
      let results = await API.getAllUsers(query);
      let resultData = results.data.result;

      setUsers(resultData.users);
      setTotal(resultData.total);
      setLimit(resultData.limit);
    } catch (error) {
      console.log(error);
    }
  }

  const getCurrentApproveQuery = () => {
    // Reconstruct extra query from 'approve' state if needed
    if (approve === 1) return "approve=1";
    if (approve === 0) return "approve=0";
    if (approve === -2) return "block=1";
    return "";
  }

  const onSearch = async (event) => {
    event.preventDefault();
    const value = event.target.value;
    setS(value);
    setPage(1);

    // Call fetch directly with new values
    fetchUsers(value, 1, limit, getCurrentApproveQuery());
  }

  const onPaginationPress = (newPage) => {
    setPage(newPage);
    fetchUsers(s, newPage, limit, getCurrentApproveQuery());
  }

  const deleteUser = async (event) => {
    event.preventDefault();
    let payload = {
      user_id: data.id
    }
    try {
      let results = await API.postDeleteUser(payload);

      if (results.result) {
        toast.success("Your action is successful", {
          data: {
            title: "Success toast",
            text: "This is a success message",
          },
        })
        fetchUsers(s, page, limit, getCurrentApproveQuery());
      }

    } catch (error) {
      console.log(error)
    }
  }

  const blockUser = async (event) => {
    event.preventDefault();
    let payload = {
      user_id: data.id,
      block: data.block ? 0 : 1
    }
    try {
      let results = await API.postBlockUser(payload);

      if (results.result) {
        toast.success("Your action is successful", {
          data: {
            title: "Success toast",
            text: "This is a success message",
          },
        })
        fetchUsers(s, page, limit, getCurrentApproveQuery());
      }

    } catch (error) {
      console.log(error)
    }
  }

  const approveUser = async (event) => {
    event.preventDefault();
    let payload = {
      id: data.id,
      approve: data.approve ? 0 : 1
    }
    try {
      let results = await API.approveUser(payload);

      if (results.result) {
        toast.success("Your action is successful", {
          data: {
            title: "Success toast",
            text: "This is a success message",
          },
        })
        fetchUsers(s, page, limit, getCurrentApproveQuery());
      }

    } catch (error) {
      console.log(error)
    }
  }

  const linkToNewPage = async (id) => {
    let element = document.getElementById(`clickview${id}`);
    if (element) element.click();
  }

  const handleSort = (val, query) => {
    setApprove(val);
    fetchUsers(s, page, limit, query);
    // Original logic reset Page?
    // "e.preventDefault(); this.state.approve = -1; this.setState({}); this.getAllUsers();"
    // Original didn't reset page explicitly in dropdown handler.
  }

  let displaySort = "All users";

  if (approve === 0) {
    displaySort = "Not yet approve";
  } else if (approve === 1) {
    displaySort = "Approve";
  } else if (approve === -2) {
    displaySort = "Block";
  }

  return (
    <div className="col-12 ">
      <ToastContainer />
      <div className="card card-body card-hover-shadow p-40">
        <h4 className="card-title"><strong>Total Users:<b className="text-success fw-500 w-80px"> {total.toLocaleString('en-US')}</b></strong> <i className="fa fa-users"> </i></h4>

        <div className="card-body">

          <div className="flexbox mb-20">
            <div className="lookup">
              <input className="w-250px" type="text" name="s" placeholder="Search" onChange={onSearch} />
            </div>

            <div className="btn-toolbar">
              <div className="btn-group btn-group-sm">


                <button className="btn btn-info dropdown-toggle" data-toggle="dropdown">Sort By: {displaySort}</button>
                <div className="dropdown-menu dropdown-menu-right">
                  <Link className="dropdown-item" onClick={(e) => {
                    e.preventDefault();
                    handleSort(-1, "");
                  }}><i className="fa fa-users"></i>All</Link>
                  <Link className="dropdown-item" onClick={(e) => {
                    e.preventDefault();
                    handleSort(1, "approve=1");
                  }}><i className="fa fa-check"></i>Approved</Link>
                  <Link className="dropdown-item" onClick={(e) => {
                    e.preventDefault();
                    handleSort(0, "approve=0");
                  }}><i className="fa fa-user"></i>Not yet approve</Link>
                  <Link className="dropdown-item" onClick={(e) => {
                    e.preventDefault();
                    handleSort(-2, "block=1");
                  }}><i className="fa fa-user-times"></i>Block</Link>
                </div>

              </div>

              <div className="btn-group btn-group-sm ml-2 d-none d-sm-flex">

                <button className="btn btn-info" onClick={(e) => {
                  e.preventDefault()
                  document.getElementById("importExcel").click()
                }}><i className="fa fa-file-excel-o"></i> Import</button>
                <input
                  type="file"
                  accept=".xlsx, .xls"
                  onChange={handleFileUpload}
                  hidden
                  id="importExcel"
                />
                &nbsp;&nbsp;<Link to="/useredit" > <button className="btn btn-primary" title="Add new" data-provide="tooltip"> <i className="ion-plus-round" ></i></button></Link>

                {/* <button className="btn btn-info dropdown-toggle" data-toggle="dropdown">Export</button> */}
                <div className="dropdown-menu dropdown-menu-right">
                  <Link className="dropdown-item"  ><i className="fa fa-file-zip-o"></i> Zip</Link>
                  <Link className="dropdown-item"  ><i className="fa fa-file-pdf-o"></i> PDF</Link>
                  {/* <Link class="dropdown-item" onClick={this.exportToExcel} ><i class="fa fa-file-excel-o"></i> Excel</Link> */}
                  {/* <Link class="dropdown-item" onClick={this.testExport(this.state.users, "user data")} ><i class="fa fa-file-excel-o"></i> Excel</Link> */}
                  <Link className="dropdown-item" onClick={(event) => { exportUsersToExcelClient(users, "user data") }}  ><i className="fa fa-file-excel-o"></i> Excel</Link>
                </div>
              </div>
            </div>
          </div>
          <div>
          </div>

          <table className="table table-hover table-has-action">
            <thead>
              <tr>
                <th className="text-center w-20px"><h6>#</h6></th>
                <th className="text-center w-40px"><h6>Profile</h6></th>
                <th className="text-center w-180px"><h6>User Name</h6></th>
                <th className="text-center w-200px"><h6>Phone Number</h6></th>
                {/* <th className="text-center w-120px"><h6>Gender</h6></th> */}
                <th className="text-center w-200px"><h6>Email</h6></th>
                <th className="text-center w-100px"><h6>Status</h6></th>
                <th className="text-center "><h6>Join Date</h6></th>
                <th className="text-center  w-200px "><h6>Actions</h6></th>
              </tr>
            </thead>
            <tbody>
              {
                users?.map((user, index) => {

                  let backgroundColor = "#46be8a";
                  let status = "Approve";

                  if (!user.approve) {
                    backgroundColor = '#fdd501';
                    status = 'Pending';
                  }

                  if (user.block) {
                    backgroundColor = '#f96868';
                    status = "Block";
                  }

                  return <tr key={index}>
                    {/* <tr style={{background: user.block? '#d9d9d9' : user.approve? ''  : 'green'} }>  style={{background: backgroundColor} } */}
                    {/* <tr style={{background: user.block? '#d9d9d9' : ''} }></tr> */}
                    {/* <tr style={user.block ? this.style : ''}></tr> */}
                    <th onClick={() => linkToNewPage(user.id)} className="text-center w-20px" scope="row"> <b>{((page - 1) * limit) + (index + 1)}</b></th>
                    {/* <td><img style={{width: 30, height: 30, borderRadius: 30}} src={user.profile_url} alt="user profile" /></td> */}
                    <td onClick={() => linkToNewPage(user.id)} className="text-center w-40px">
                      <div className="media">
                        {/* <img class="avatar" src={user.profile_url ? user.profile_url : require('../../assets/assets_theme/img/avatar/1.jpg')} alt="..." /> */}
                        <img className="avatar" src={user.profile_url ? user.profile_url : img1} alt="..." />
                        <div className="media-body">
                          {/* <p >{video.title_kh}</p> */}
                        </div>
                      </div>
                    </td>
                    <td onClick={() => linkToNewPage(user.id)} className="text-center w-180px"><strong>{user.last_name + ' ' + user.first_name}</strong></td>
                    <td onClick={() => linkToNewPage(user.id)} className="text-center w-200px">{user.phone_number}</td>
                    {/* <td className="text-center w-120px">{user.gender_id === 1 ? "Male" : user.gender_id === 2 ? "Female" : "Other"}</td> */}
                    <td onClick={() => linkToNewPage(user.id)} className="text-center w-200px">{user.email}</td>
                    <td onClick={() => linkToNewPage(user.id)} className="text-center "><p style={{ background: backgroundColor, color: '#FFFFFF', borderRadius: 25 }}><strong>{status}</strong></p></td>
                    <td onClick={() => linkToNewPage(user.id)} className="text-center w-150px">{moment(user.created_at).format("DD-MMM-YYYY")}</td>
                    {/* <td className="text-right table-actions"></td> */}
                    <td className="text-center table-actions text-center ">
                      {/* <Link title="View" class="btn btn-square btn-round btn-primary" to={`/useredit?id=${user.id}`}><i className="fa fa-eye"></i></Link> */}
                      <span>&nbsp;</span><Link title="Edit" className="btn btn-square btn-round btn-info" to={`/useredit?id=${user.id}`}><i id={`clickview${user.id}`} className="ti-pencil"></i></Link>


                      <span>&nbsp;</span><Link title="Block" className="btn btn-square btn-round btn-warning"><i className="fa fa-user-times" data-toggle="modal" data-target="#modal-center-blockuser" onClick={() => setData(user)}></i></Link>
                      <span>&nbsp;</span><Link title="Approve" className="btn btn-square btn-round btn-primary"><i className="fa fa-check" data-toggle="modal" data-target="#modal-center-approveuser" onClick={() => setData(user)}></i></Link>
                      <span>&nbsp;</span><Link title="Delete" onClick={() => setData(user)} className="btn btn-square btn-round btn-danger"><i className='ti-trash' data-toggle="modal" data-target="#modal-center" ></i> </Link>

                      {/* btn-outline fa fa-minus-square*/}
                      {/* <Link className="table-action hover-primary" title="View" to={`/userview?id=${user.id}`}><i className="fa fa-eye"></i></Link>
                        <Link className="table-action hover-primary" title="Edit" to={`/useredit?id=${user.id}`}><i class="ti-pencil"></i></Link>
                        <span>&nbsp;</span><i className="fa fa-minus-square table-action hover-danger" data-toggle="modal" data-target="#modal-center" title="Block" onClick={() => this.setState({data: user})}></i> */}



                      {/* <i className="ti-trash table-action hover-danger" data-toggle="modal" data-target="#modal-center" title="Delete" onClick={() => this.setState({data: user})}></i>  */}


                      {/* <div className="dropdown table-action">
                          <span className="dropdown-toggle no-caret hover-primary" data-toggle="dropdown" title="More"><i class="ti-more-alt rotate-90"></i></span>
                          <div className="dropdown-menu dropdown-menu-right">
                            <a className="dropdown-item" href="/"><i class="ti-menu-alt"></i> Details</a>
                            <a className="dropdown-item" href="/"><i class="ti-clip"></i> Add file</a>
                            <a className="dropdown-item" href="/"><i class="ti-bar-chart"></i> Performance</a>
                          </div>
                        </div> */}
                    </td>
                  </tr>
                })
              }
            </tbody>
          </table>
          <Pagination
            onPaginationPress={onPaginationPress}
            totalPageLength={total}
            limit={limit}
            selectPage={page}
          />
        </div>
      </div>
      {
        data &&
        <CustomModal
          data={data}
          title="Do you really want to delete this user?"
          deleteQuiz={deleteUser}
        />
      }
      {
        data &&
        <CustomModalBlockUser
          data={data}
          title={data.block ? "Do you really want to unblock this user?" : "Do you really want to block this user?"}
          blockUser={blockUser}
          approveUser={approveUser}
        />
      }
      {
        data &&
        <CustomModalApproveUser
          data={data}
          title={data.block ? "Do you really want to approve this user?" : "Do you really want to disapprove this user?"}
          // blockUser = {this.blockUser}
          approveUser={approveUser}
        />
      }
    </div>
  );
}

export default UserIndex;
